<template>
  <span class="symbol" :class="size">G</span>
</template>

<style scoped>
  .symbol {
    color: #999;
    border-style: solid;
    border-color: #f4b844;
    background-color: #fedb41;
    color: #a26f0e;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
  }

  .symbol.medium {
    font-size: 1em;
    height: 30px;
    width: 30px;
    border-width: 3px;
  }

  .symbol.small {
    font-size: 0.9em;
    height: 20px;
    width: 20px;
  }

  .symbol.large {
    font-size: 1.1em;
    height: 30px;
    width: 30px;

  }
</style>

<script>
  import { defineComponent } from 'vue';
  export default defineComponent({
    name: 'GimoCoinSymbol',
    props: {
      size: {
        type: String,
        default: 'medium'
      }
    }
  });
</script>
